const reviewSections = [
  {
    title: 'Project Details',
    fields: [
      { key: 'service', label: 'Service' },
      { key: 'projectType', label: 'Project Type' },
      { key: 'budget', label: 'Budget' },
      { key: 'timeline', label: 'Timeline' },
      { key: 'description', label: 'Description' },
      { key: 'referenceUrl', label: 'Reference URL' }
    ]
  },
  {
    title: 'Contact Information',
    fields: [
      { key: 'name', label: 'Name' },
      { key: 'company', label: 'Company' },
      { key: 'email', label: 'Email' },
      { key: 'phone', label: 'Phone' },
      { key: 'country', label: 'Country' },
      { key: 'preferredCommunication', label: 'Preferred Channel' },
      { key: 'website', label: 'Website' }
    ]
  },
  {
    title: 'Meeting Schedule',
    fields: [
      { key: 'timezone', label: 'Timezone' },
      { key: 'preferredDate', label: 'Preferred Date' },
      { key: 'preferredTime', label: 'Preferred Time' },
      { key: 'meetingDuration', label: 'Duration' },
      { key: 'meetingPurpose', label: 'Purpose' }
    ]
  }
];

export function StepReview({ values }) {
  return (
    <div className="booking-step">
      <div className="booking-step__intro">
        <p className="eyebrow">Step 4</p>
        <h3>Review</h3>
        <p>Confirm everything looks right before we prepare your consultation request.</p>
      </div>

      <div className="booking-review">
        {reviewSections.map((section) => (
          <section className="booking-review__card glass-panel" key={section.title}>
            <h4>{section.title}</h4>
            <dl>
              {section.fields.map((field) => (
                <div key={field.key}>
                  <dt>{field.label}</dt>
                  <dd>{values[field.key]?.trim() ? values[field.key] : '—'}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </div>
  );
}
